export default __webpack_public_path__ + "static/for-hire-1-f6f477c436660d0a3f409d4e1e68c41a.jpg";